import { render, staticRenderFns } from "./Expression.vue?vue&type=template&id=5987213a&"
import script from "./Expression.vue?vue&type=script&lang=js&"
export * from "./Expression.vue?vue&type=script&lang=js&"
import style0 from "./Expression.vue?vue&type=style&index=0&id=5987213a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports